export interface Entry {
  id: string;
  itemId: string;
  code?: string | null;
  name: string;
  section: string;
  opening: number | string;
  purchases: number | string;
  sales: number | string;
  physicalCount?: number | string | null;
  leftCook: number | string;
  damages: number | string;
  short: number | string;
  lend: number | string;
  borrow: number | string;
  closing: number | string;
  variance?: number | string | null;
}

export type AdjustmentKey = "leftCook" | "damages" | "short" | "lend" | "borrow";

export const ADJUSTMENT_FIELDS: { key: AdjustmentKey; label: string }[] = [
  { key: "leftCook", label: "Left cook" },
  { key: "damages", label: "Damages" },
  { key: "short", label: "Short" },
  { key: "lend", label: "Lend" },
  { key: "borrow", label: "Borrow" },
];

// API decimals may arrive as strings (Prisma Decimal JSON), so coerce.
export function toNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
}

export function formatQuantity(value: number | string | null | undefined) {
  const num = toNumber(value);
  if (num === null) return "—";
  return num.toLocaleString("en-ZA", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function getVarianceMeta(variance: number | string | null | undefined) {
  const num = toNumber(variance);
  if (num === null) {
    return { label: "Pending count", tone: "muted" as const };
  }
  if (num < 0) return { label: "Short", tone: "danger" as const };
  if (num > 0) return { label: "Over", tone: "warning" as const };
  return { label: "Balanced", tone: "success" as const };
}

export function isCounted(entry: Entry) {
  return entry.physicalCount !== null && entry.physicalCount !== undefined && entry.physicalCount !== "";
}

export function hasAdjustments(entry: Entry) {
  return ADJUSTMENT_FIELDS.some(({ key }) => (toNumber(entry[key]) ?? 0) !== 0);
}

// Local calendar date — toISOString() would shift to the previous day late at
// night in UTC+ timezones.
export function localISODate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
